import React, { Component } from 'react'
import {delay} from '../Animations/helper'

class BaseInfo extends Component {

    static propTypes = {
        onHide: React.PropTypes.func.isRequired,
        id: React.PropTypes.string.isRequired,
        event: React.PropTypes.object.isRequired,
        width: React.PropTypes.number.isRequired,
        height: React.PropTypes.number.isRequired
    }

    componentDidMount() {        
        delay(7000).then(() => {
            this.info.classList.remove("showFromBottom");
            this.info.addEventListener("animationend", () => {this.props.onHide(this)}, false);
            this.info.classList.add("hideSlow");
        })
    }

    renderContent() {
        return 'content';
    }
    
    render() {               
        return (<div ref={(ref) => this.info = ref} className="infoPopup showFromBottom" style={{width: this.props.width+'px', height: this.props.height+'px'}}>
                        <div className="pefl-modal-body">
                            {this.renderContent()}
                        </div>
                </div>)
    }
}

export default BaseInfo


/** WEBPACK FOOTER **
 ** ./src/components/Info/BaseInfo.js
 **/